import type { FC } from "react";

import type { ShopSchedule } from "@jti/fe-common";

import styles from "./StoreLocatorDayShopSchedule.module.scss";

type StoreLocatorDayShopScheduleProps = {
  isOpeningHoursBreaksEnabled: boolean;
  day: ShopSchedule;
};

export const StoreLocatorDayShopSchedule: FC<StoreLocatorDayShopScheduleProps> = ({
  isOpeningHoursBreaksEnabled,
  day,
}) => {
  if (isOpeningHoursBreaksEnabled && day.break_start_time && day.break_end_time) {
    return (
      <div className={styles.shopBreaksSchedule} data-testid="shopBreaksSchedule">
        <div>
          {day.open_time} - {day.break_start_time}
        </div>
        <div>
          {day.break_end_time} - {day.close_time}
        </div>
      </div>
    );
  }

  return (
    <>
      {day.open_time} - {day.close_time}
    </>
  );
};
